import {useState} from "react";
import appConstants from "../../constants";

const SEARCH_RESULT_TAB_FOUND_PARTNERS = 'found partners';
const SEARCH_RESULT_TAB_SAVED_PARTNERS = 'saved partners';
const SEARCH_RESULT_TAB_MY_PARTNERS = 'my partners';

const constants = Object.freeze({
  SEARCH_RESULT_TAB_FOUND_PARTNERS: SEARCH_RESULT_TAB_FOUND_PARTNERS,
  SEARCH_RESULT_TAB_SAVED_PARTNERS: SEARCH_RESULT_TAB_SAVED_PARTNERS,
  SEARCH_RESULT_TAB_MY_PARTNERS:    SEARCH_RESULT_TAB_MY_PARTNERS,
  SEARCH_RESULT_TABS: [
    SEARCH_RESULT_TAB_FOUND_PARTNERS,
    SEARCH_RESULT_TAB_SAVED_PARTNERS,
    SEARCH_RESULT_TAB_MY_PARTNERS
  ],
  SEARCH_RESULT_TAB_DEFAULT: SEARCH_RESULT_TAB_FOUND_PARTNERS
});

const defaults = Object.freeze( {
  initialActiveResultTab: constants.SEARCH_RESULT_TAB_DEFAULT
});

export default function useSearchResultsTabNavigation() {
  const [activeSearchResultTab, setActiveSearchResultTab] = useState(defaults.initialActiveResultTab);

  function activateResultTab(searchResultTab) {
    if (constants.SEARCH_RESULT_TABS.includes(searchResultTab)) {
      setActiveSearchResultTab(searchResultTab);
    }
    else {
      appConstants.APP_DEBUG_LOGGER(`Invalid partner search result tab: ${searchResultTab}`);
    }
  }

  function isSearchResultTabActive(resultTab) {
    return resultTab === activeSearchResultTab;
  }

  function activateFoundPartners() {
    activateResultTab(constants.SEARCH_RESULT_TAB_FOUND_PARTNERS);
  }

  function isFoundPartnersActive() {
    return isSearchResultTabActive(constants.SEARCH_RESULT_TAB_FOUND_PARTNERS);
  }

  function activateSavedPartners() {
    activateResultTab(constants.SEARCH_RESULT_TAB_SAVED_PARTNERS);
  }

  function isSavedPartnersActive() {
    return isSearchResultTabActive(constants.SEARCH_RESULT_TAB_SAVED_PARTNERS);
  }

  function activateMyPartners() {
    activateResultTab(constants.SEARCH_RESULT_TAB_MY_PARTNERS);
  }

  function isMyPartnersActive() {
    return isSearchResultTabActive(constants.SEARCH_RESULT_TAB_MY_PARTNERS);
  }

  function getActiveResultTab() {
    return activeSearchResultTab;
  }

  return {
    activateFoundPartners,
    isFoundPartnersActive,
    activateSavedPartners,
    isSavedPartnersActive,
    activateMyPartners,
    isMyPartnersActive,

    getActiveResultTab
  };
}
